// Brand assets are served by the backend at /api/static/brand/ (swappable files).
const BRAND_BASE = `${process.env.REACT_APP_BACKEND_URL}/api/static/brand`;

export const BRAND = {
  logo: `${BRAND_BASE}/logo.svg`,
  logoMark: `${BRAND_BASE}/logo_mark.svg`,
  wordmark: `${BRAND_BASE}/wordmark.svg`,
  crush: `${BRAND_BASE}/crush.svg`,
  super_crush: `${BRAND_BASE}/super_crush.svg`,
  wink: `${BRAND_BASE}/wink.svg`,
  blink: `${BRAND_BASE}/blink.svg`,
};

export const FACE_LABELS = { crush: "Crush", super_crush: "Super Crush", wink: "Wink", blink: "Blink" };

export function Logo({ className = "h-8", testId = "brand-logo" }) {
  return <img src={BRAND.logo} alt="Crushwink" className={`${className} w-auto`} data-testid={testId} />;
}

export function LogoMark({ className = "h-10 w-10", testId = "brand-logo-mark" }) {
  return <img src={BRAND.logoMark} alt="Crushwink" className={className} data-testid={testId} />;
}

export function Face({ name, className = "h-12 w-12" }) {
  return <img src={BRAND[name]} alt={FACE_LABELS[name]} className={className} data-testid={`face-${name}`} />;
}
